<ph-skeleton *ngIf="fileLoading" lines="1" size="lg" width="full" [style.height]="containerHeight"></ph-skeleton>

<ph-empty-state *ngIf="!fileLoading && loadFailed"
                icon="warning"
                heading="This attachment could not be loaded"
                center
                [style.height]="containerHeight">
    The file is not available right now. Download it to open it, or try again in a moment.
</ph-empty-state>

<ng-container *ngIf="!fileLoading && !loadFailed">
    <ng-container [ngSwitch]="attachmentType">
        <pdf-viewer
            *ngSwitchCase="'pdf'"
            [autoresize]="true" [external-link-target]="'blank'"
            [fit-to-page]="true" [original-size]="false" [render-text]="true" [rotation]="0"
            [show-all]="true" [src]="currentSrc" [stick-to-page]="false"
            [zoom]="1"
            [style.width]="'100%'"
            [style.height]="containerHeight">
        </pdf-viewer>
        <div *ngSwitchCase="'docx'" class="overflow-auto" [style.height]="containerHeight">
            <div #docxContainer></div>
        </div>
        <div *ngSwitchCase="'txt'" [style.height]="containerHeight" class="overflow-auto">
            <pre class="overflow-auto p-4 bg-white">{{ currentSrc }}</pre>
        </div>
        <div *ngSwitchDefault class="overflow-auto text-center" [style.height]="containerHeight">
            <img *ngIf="isPreviewableImage; else noInlinePreview" [src]="currentSrc" (loadstart)="fileLoading = true" class="img-fluid" (loadeddata)="fileLoading = false" alt="Invoice Preview">
            <!-- SD-8230: downloadable but not displayable. Say so instead of rendering a broken image. -->
            <ng-template #noInlinePreview>
                <ph-empty-state icon="file-text" heading="This file type cannot be previewed" center [style.height]="containerHeight">
                    Download it to open it.
                </ph-empty-state>
            </ng-template>
        </div>
    </ng-container>
</ng-container>
